import { Badge } from '@ui';
import { useTranslation } from 'react-i18next';
import { MemberFileValidity } from './types';

export const FileValidityBadge = ({ validity }: { validity: MemberFileValidity }) => {
    const { t } = useTranslation('member-management');

    if (validity === 'expired') {
        return (
            <Badge size="xs" color="error" flat>
                {t('clubMember.files.badges.expired')}
            </Badge>
        );
    }

    if (validity === 'expiring') {
        return (
            <Badge size="xs" color="warning" flat>
                {t('clubMember.files.badges.expiringSoon')}
            </Badge>
        );
    }

    return null;
};

export default FileValidityBadge;
